import axios from 'axios';
import { AUTH } from '../config/apiPaths';
import { isWellFormedCode } from '../utils/unifiedSignIn';

/**
 * Ask the API for a single-use hand-off code (valid ~60 s) for the signed-in user.
 * Uses a bare axios call on purpose: the shared client's 401 handling would try to refresh
 * and redirect, which is wrong for this one-off request. Resolves to null on ANY failure
 * (including 404 while the backend endpoint is not deployed yet) so callers fall back to
 * the tenant app's own sign-in; the access token is never put in a URL.
 */
export async function issueHandoffCode(token: string): Promise<string | null> {
  try {
    const res = await axios.post(
      AUTH.HANDOFF,
      {}, // a global middleware rejects POSTs without a Content-Type
      {
        baseURL: import.meta.env.GO_SERVER_API_URL || '/api',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        timeout: 10000,
      },
    );
    const code = res?.data?.code;
    return isWellFormedCode(code) ? code : null;
  } catch {
    return null;
  }
}
